<template>
<!-- Stepper Template -->
    <v-app>
        <v-stepper v-model="stepper" vertical>
                <v-stepper-step editable step="1">
                    Body Chart
                </v-stepper-step>
                <v-stepper-content step="1">
                    <anatomy ref="anatomy"></anatomy>
                </v-stepper-content>
                <v-stepper-step editable step="2">
                    Remarks
                </v-stepper-step>
                <v-stepper-content step="2">
                    <remarks ref="remarks" ></remarks>
                </v-stepper-content>
                <v-stepper-step editable step="3">
                    Foot Profile
                </v-stepper-step>
                <v-stepper-content step="3">
                    <feet ref="feet"></feet>
                </v-stepper-content>
                <v-stepper-step editable step="4">
                    EMG Screening
                </v-stepper-step>
                <v-stepper-content step="4">
                    <screening ref="screening" ></screening>
                </v-stepper-content>
                 <v-stepper-step editable step="5">
                  Strength Test
                </v-stepper-step>
                <v-stepper-content step="5">
                    <strength ref="strength" @submitForm="submit()"></strength>
                </v-stepper-content>
        </v-stepper>
    </v-app>
</template>
<script>
import Anatomy from '@/views/form2/Anatomy';
import Feet from '@/views/form2/Feet';
import Screening from '@/views/form2/Screening';
import Remarks from '@/views/form2/Remarks';
import Strength from '@/views/form2/Strength';

export default {
    props:['form_id'],
    data(){
        return{
            stepper: 0,
        }
    },
    components:{
        'anatomy' : Anatomy,
        'feet' : Feet,
        'screening' : Screening,
        'remarks' : Remarks,
        'strength': Strength
    },
    methods:{
        submit(){
           // console.log('FORM2 SUBMIT LOG' + this.form_id);
             this.$refs.feet.submit(this.form_id);
            this.$refs.remarks.submit(this.form_id);
            this.$refs.anatomy.submit(this.form_id);
            this.$refs.screening.submit(this.form_id);
            this.$refs.strength.submit(this.form_id);
            this.$emit('submitted');
        }
    }
}
</script>

